module.exports = __webpack_public_path__ + "img/lta-banner.5752284a.jpg";